import { render, staticRenderFns } from "./SpoolerSpoolerButton.vue?vue&type=template&id=1154d1f5&"
import script from "./SpoolerSpoolerButton.vue?vue&type=script&lang=ts&"
export * from "./SpoolerSpoolerButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports